import {
  D2cEventResponseDto,
  EcommerceNaPraticaResponseDto,
} from '@tiendanube/common';
import { cirrusApi } from 'App/rtk';
import {
  DashboardEndpoints,
  D2C_EVENT_URL,
  ECOMMERCE_NA_PRATICA_URL,
} from './config';

export const dashboardApi = cirrusApi.injectEndpoints({
  endpoints: (builder) => ({
    [DashboardEndpoints.getEcommerceNaPratica]: builder.query<
      EcommerceNaPraticaResponseDto,
      void
    >({
      query: () => ({
        method: 'GET',
        url: ECOMMERCE_NA_PRATICA_URL,
      }),
    }),
    [DashboardEndpoints.getD2cEvent]: builder.query<D2cEventResponseDto, void>({
      query: () => ({
        method: 'GET',
        url: D2C_EVENT_URL,
      }),
    }),
  }),
});

export const { useGetEcommerceNaPraticaQuery, useGetD2cEventQuery } =
  dashboardApi;
